import React, { FC, useContext, useState } from 'react'
import { KTSVG } from '../../../../../../_metronic/helpers'
import * as Yup from 'yup'
import { useFormik } from 'formik'
 
 
import {useNavigate, useParams} from 'react-router-dom'
import { AlertContext } from '../../../../../../_metronic/layout/components/alert-context'
import {  Plan, initialValues } from '../plan-list/core/_models'
import { updatePlanBackendSettings } from '../plan-list/core/_requests'
 


 
const sobDetailsSchema = Yup.object().shape({
  planInfoTitle: Yup.string().required('Title is required'),
  
  PlanInfoDetails: Yup.string().required('Details  is required'),
})
type Props = {
  initialValues: Plan
}
export const EditPlan: FC<Props> = ({initialValues}) => {

  const{showAlert}=useContext(AlertContext);
  const navigate = useNavigate()
  const [formImage, setFormImage] = useState<File | null>(null)
  const [data, setData] = useState<Plan>(initialValues)
   {/* Add Row and column Multiple*/}
  const { id }=useParams();
  const [btnDisable, setbtnDisable] = useState(true)
 

  const [loading, setLoading] = useState(false)
  const formik = useFormik<Plan>({
    initialValues,
    validationSchema: sobDetailsSchema,
    onSubmit: (values) => {
      setLoading(true)
      setTimeout(() => {
        const updatedData = Object.assign(data, values)
        
        const formData = new FormData()
        formData.append('PlanInfoDetails', updatedData?.PlanInfoDetails)
        formData.append('planInfoTitle', updatedData?.planInfoTitle)
         
        const segments = updatedData?.planInfoImage.split('/');
const image = segments.pop();
        formData.append('oldimage', image)
     
        if (formImage) formData.append('planInfoImage', formImage)
        updatePlanBackendSettings(formData).then((res:any) => {
         showAlert(res?.Message,res?.Code);
         navigate('/mobile-settings/list', {replace: true},)
         }) 
       
         setLoading(false)
      }, 1000)
    }, 
  })
  // 
  const imageHandler = (e: { target: { files: any } }) => {
    formik.handleChange(e);
   const reader = new FileReader()
   reader.onload = () => {
    // 
     if (reader.readyState === 2) {
      
      
      setData({
       ...data,
       planInfoImage: reader.result,
     })
    
  }
   }
  
  
   const files = e.target.files
  
   if (files) {
     setFormImage(files[0])
     reader.readAsDataURL(files[0])
   }
   if (data?.planInfoImage !== null) {
     
     setbtnDisable(false);
   }
  }
  return (
    <> <form onSubmit={formik.handleSubmit} noValidate className='form'>
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Edit Plan</h3>
        </div>
       
      </div>
     
      <div id='kt_account_profile_details'>


        <div className='card-body border-top p-9'>

        <div className='row'>
          {/** name */}
          <div className='mb-6 col-lg-6'>
            <label className='col-lg-12 col-form-label required fw-bold fs-6'>Plan Heading</label>
            <div className='col-lg-12'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Enter banner name'
                {...formik.getFieldProps('planInfoTitle')}
              />
              {formik.touched.planInfoTitle && formik.errors.planInfoTitle && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.planInfoTitle}</div>
                </div>
              )}
            </div>
          </div>
            
          {/** title */}
          <div className='mb-6 col-lg-6'>
            <label className='col-lg-12 col-form-label required fw-bold fs-6'>Plan Details</label>
            <div className='col-lg-12'>
              <textarea
                
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Enter banner name'
                {...formik.getFieldProps('PlanInfoDetails')}
              />
              {formik.touched.PlanInfoDetails && formik.errors.PlanInfoDetails && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.PlanInfoDetails}</div>
                </div>
              )}
            </div>
          </div>
          </div>
          <div className='row'>
          {/** image */}
          <div className='col-lg-6 mb-6'>
            <label className='col-lg-12 col-form-label  fw-bold fs-6'>Plan Image</label>
            <div className='col-lg-12'>
              <input
                type='file' 
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Enter banner name' 
                {...formik.getFieldProps('editbannerimage')} 
                onChange={imageHandler}
              />
              
            </div>
            <div className='col-lg-12'>
            <label className='col-lg-12 col-form-label  fw-bold fs-6'>Old Plan Image</label>
            
              <img src={initialValues.planInfoImage} style={{height:'100px',width:'250px'}}/>
            </div>
          </div>
           
          </div>
          <div className='card-footer d-flex justify-content-end py-6 px-9'>
                <button type='submit'     className='btn btn-sm text-white'
           style={{background: '#9E2A8D'}} disabled={loading}>
                  {!loading && 'Save Changes'}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
        </div>
      </div>
    </div>
    

  </form>
    </>
  )
                    }

export default EditPlan
 

